import ComercializationSummaryWidget from './ComercializationSummaryWidget';

export default ComercializationSummaryWidget;
